import { useParams, useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import PersonDetailView from '../components/persons/PersonDetailView';

/**
 * Rota full-screen de detalhe da pessoa (/persons/:id).
 */
export default function PersonDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <Box sx={{ p: { xs: 1, md: 2 } }}>
      <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/persons')} sx={{ mb: 1 }}>
        Voltar
      </Button>
      <PersonDetailView personId={id} />
    </Box>
  );
}
